//调用 $store.state.test
var state = {
  loading: false,
  env: process.env.VUE_APP_URL //获取地址

};
export default state;